import { isNullOrUndefined } from './helpers';

export default {};

export const currencyFormatter = (value, includeGap = true) => {
  let ourValue = value ?? 0;
  if (typeof value === 'number') {
    ourValue = ourValue.toFixed(2);
  }
  return `$${includeGap ? ' ' : ''}${ourValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace((/(?<=\.\d{2}).*/g), '');
};

export const currencyParser = (value) => value.replace(/\$\s?|(,*)/g, '');

export const materialCostFormatter = (value, includeGap = true) => {
  let ourValue = value ?? 0;
  if (typeof value === 'number') {
    ourValue = ourValue.toFixed(5);
  }
  // only add ',' for the integer part
  const [intPart, decPart] = ourValue.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formatted = isNullOrUndefined(decPart) ? formattedInt : `${formattedInt}.${decPart}`;
  return `$${includeGap ? ' ' : ''}${formatted}`.replace(/(?<=\.\d{5}).*/g, '');
};

export const percentFormatter = (value) => {
  if (!value) return '';
  let ourValue = value;
  if (typeof value === 'number') {
    ourValue = ourValue.toFixed(2);
  }
  return `${ourValue}%`;
};

export const percentParser = (value) => value.replaceAll('%', '');

export const markupPercentFormatter = (value) => {
  if (!value) return '';
  let ourValue = value;
  if (typeof value === 'number') {
    ourValue = parseFloat(ourValue.toFixed(5));
  }
  return `${ourValue}%`;
};
